import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useUpdateCheck } from 'react-update-notification';
import { useEffect, useState } from 'react';

export const VersionUpdateNotificationContainer = () => {
    const [visible, setVisible] = useState(false);
    const { status, reloadPage } = useUpdateCheck({
        type: 'interval',
        interval: 60000
    });

    const setReminder = () => {
        setTimeout(() => {
            setVisible(true);
        }, 60000);
        setVisible(false);
    };

    useEffect(() => {
        setVisible(status === 'available');
    }, [status]);

    return (
        <Modal title="بروزرسانی"
            visible={visible}
            onOk={reloadPage}
            onCancel={setReminder}
            bodyStyle={{ textAlign: 'center' }}
            okText="باشه"
            cancelText="یادآوری مجدد!"
        >
            <p>
                <ExclamationCircleOutlined style={{ color: "orange", fontSize: 48 }} />
            </p>
            <p>نسخه جدید نرم افزار موجود است، آیا مایلید بروزرسانی انجام شود؟</p>
            <p>در صورت عدم بروزرسانی، ممکن است کاربری نرم افزار با مشکل مواجه شود. اگر عملیات ناتمام دارید می توانید بروزرسانی را به تعویق بیاندازید.</p>
        </Modal>
    );
};